import { db } from "../../fireBase/firebase";

import { serverTimestamp, doc, setDoc } from "firebase/firestore";


export const handleSubmission = async (object, func, clear) => {

    try {
        await setDoc(doc(db, "leads", `${object.clientName} ${Math.random()* 10}${Math.ceil(new Date().getSeconds() / 50)}`),
        {
            clientName : object.clientName,
            clientEmail : object.clientEmail,
            clientPhonNo : object.clientPhonNo,
            clientBusType : object.clientBusType,
            clientPackage : object.clientPackage,
            clientWebSite : object.clientWebSite,
            createdAt: serverTimestamp()
        });

        await func('pass-submitted!, thanks you');
        await clear();
        
        
    } catch (error) {
        console.error("Error adding document: ", error);
        func('error-sorry, unable to submit');
    }
}
  